const doc = [({"en":({"js":({"admin":({"photo_sessions":({"upload_csv_modal":({"index":({"choose_csv_type":"Choose csv type", "upload_csv_file":"Upload csv file"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;